import { get } from 'lodash';
import { createSelector } from 'reselect';

import { makeOptionsData, makeOptionsDataRemoveEmpty } from 'Common/FormHelper';
import { getSites } from 'State/selectors';
import { getGrades } from 'State/grades/selectors';
import { StudentProfileEnum } from 'Common/FieldEnum';
import {
  AeriesMapOptions,
  AeriesPreviewFields,
} from 'Common/Constants/SISIntegration';

const root = (state) => get(state, 'AeriesIntegrationState');
export const getConfiguration = (state) => get(root(state), 'configuration');
export const getMapping = (state) => get(root(state), 'mapping');
export const getLanguages = (state) => get(root(state), 'languages');
export const getPreview = (state) => get(root(state), 'preview');
export const getManualSync = (state) => get(root(state), 'manualSync');

export const getSiteOptions = createSelector(getSites, (sites) =>
  makeOptionsDataRemoveEmpty(
    sites.filter((s) => s.IsActive && s.IsLicensed),
    true
  )
);

export const getGradeOptions = createSelector(getGrades, (grades) =>
  makeOptionsData(grades, {
    keyKey: 'Id',
    valueKey: 'Id',
    textKeys: ['Id', 'Description'],
  })
);

export const getLanguageOptions = createSelector(getLanguages, (languages) =>
  makeOptionsData(languages.data)
);

export const getReducePreviewData = createSelector(
  getPreview,
  getGradeOptions,
  getSiteOptions,
  getLanguageOptions,
  (preview, gradeOptions, siteOptions, languageOptions) => {
    const data = preview.data;

    if (data) {
      const formatters = {
        [StudentProfileEnum.LanguageId]: (key) => {
          const language = languageOptions.find((l) => l.key === data[key]);
          if (language) {
            return { key: AeriesMapOptions.Language, value: language.text };
          }
          return getDefault(key);
        },
        Site: (key) => {
          const site = siteOptions.find((i) => i.key === data[key]);
          if (site) {
            return { key, value: site.text };
          }
          return getDefault(key);
        },
        Grade: (key) => {
          const grade = gradeOptions.find((i) => i.key === data[key]);
          if (grade) {
            return { key, value: grade.text };
          }
          return getDefault(key);
        },
      };

      const getDefault = (valueAndList) => {
        const myKey = Object.keys(valueAndList.list).find(
          (key) => valueAndList.list[key] === valueAndList.item
        );

        return { key: valueAndList.item, value: data[myKey] };
      };
      return Object.values(AeriesPreviewFields).map((value) =>
        get(
          formatters,
          value,
          getDefault
        )({ item: value, list: AeriesPreviewFields })
      );
    }
    return null;
  }
);



// WEBPACK FOOTER //
// ./src/pages/aeriesintergration/state/selectors.js